import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const ProductShowcaseSection = () => {
  const { language } = useLanguage();
  const [activeProduct, setActiveProduct] = useState(0);

  const products = [
    {
      id: 'flowmeters',
      name: {
        fr: 'Débitmètres à ultrasons',
        ar: 'مقاييس التدفق بالموجات فوق الصوتية',
        en: 'Ultrasonic Flowmeters'
      },
      description: {
        fr: 'Le PanaFlow LC (XMT1000) est la dernière génération de débitmètres à ultrasons clamp-on pour applications de processus de Panametrics. Il offre un traitement de signal amélioré et des performances supérieures, utilisant la technologie Transit-Time pour la mesure de liquides purs et même de mélanges difficiles gaz-solide-liquide.',
        ar: 'إن PanaFlow LC (XMT1000) هو الجيل الأحدث من مقاييس التدفق بالموجات فوق الصوتية المشبكية لتطبيقات العمليات من Panametrics. يوفر معالجة محسنة للإشارة وأداءً فائقًا، باستخدام تقنية وقت العبور لقياس السوائل النقية وحتى خلائط الغاز والصلب والسائل الصعبة.',
        en: 'The PanaFlow LC (XMT1000) is the latest generation of Ultrasonic Clamp-On Liquid Flow Meters for Process Applications from Panametrics. It features improved signal processing and superior performance, using Transit-Time technology for measuring pure liquids and even difficult gas-solid-liquid mixtures.'
      },
      features: [
        {
          fr: 'PanaFlow LC - Technologie Transit-Time avancée',
          ar: 'PanaFlow LC - تقنية وقت العبور المتقدمة',
          en: 'PanaFlow LC - Advanced Transit-Time Technology'
        },
        {
          fr: 'Installation clamp-on non intrusive sur tuyaux pleins',
          ar: 'تركيب مشبكي غير متداخل على الأنابيب الممتلئة',
          en: 'Non-intrusive clamp-on installation on full pipes'
        },
        {
          fr: 'Traitement de signal amélioré et performances supérieures',
          ar: 'معالجة محسنة للإشارة وأداء فائق',
          en: 'Improved signal processing and superior performance'
        }
      ],
      color: '#3182CE',
      image: 'https://drive.google.com/thumbnail?id=10K6HZpqgA_VfHA6vunmKhIATXHQBnGFB&sz=w1000',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
        </svg>
      )
    },
    {
      id: 'gas-analyzers',
      name: {
        fr: 'Analyseurs de gaz',
        ar: 'محللات الغاز',
        en: 'Gas Analyzers'
      },
      description: {
        fr: 'Analyseurs de gaz Panametrics XMO2 XP de haute précision utilisant la technologie paramagnétique pour la surveillance continue de la composition des gaz dans les processus critiques du secteur Pétrole, Gaz et Industrie. Solutions certifiées pour zones dangereuses avec interface utilisateur intuitive.',
        ar: 'محللات الغاز Panametrics XMO2 XP عالية الدقة باستخدام التقنية المغناطيسية للمراقبة المستمرة لتركيب الغاز في العمليات الحرجة لقطاع النفط والغاز والصناعة. حلول معتمدة للمناطق الخطرة مع واجهة مستخدم بديهية.',
        en: 'High-precision Panametrics XMO2 XP gas analyzers using paramagnetic technology for continuous monitoring of gas composition in critical Oil, Gas and Industry processes. Certified solutions for hazardous areas with intuitive user interface.'
      },
      features: [
        {
          fr: 'Technologie paramagnétique pour analyse d\'oxygène',
          ar: 'تقنية مغناطيسية لتحليل الأكسجين',
          en: 'Paramagnetic technology for oxygen analysis'
        },
        {
          fr: 'Certifications ATEX et IECEx pour zones dangereuses',
          ar: 'شهادات ATEX و IECEx للمناطق الخطرة',
          en: 'ATEX and IECEx certifications for hazardous areas'
        },
        {
          fr: 'Interface graphique couleur avec enregistrement continu',
          ar: 'واجهة رسومية ملونة مع تسجيل مستمر',
          en: 'Color graphical interface with continuous data logging'
        }
      ],
      color: '#805AD5',
      image: 'https://drive.google.com/thumbnail?id=12VM-51CEC-tBohkyI8XIFBK65WWujutH&sz=w1000',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
        </svg>
      )
    },
    {
      id: 'moisture-analyzers',
      name: {
        fr: 'Analyseurs d\'humidité',
        ar: 'محللات الرطوبة',
        en: 'Moisture Analyzers'
      },
      description: {
        fr: 'Analyseurs d\'humidité Panametrics Moisture IQ utilisant la technologie laser à diode accordable (TDLAS) pour la mesure précise et en temps réel du point de rosée et de la teneur en humidité dans les gaz industriels. Surveillance critique pour les processus du secteur Pétrole, Gaz et Industrie.',
        ar: 'محللات الرطوبة Panametrics Moisture IQ باستخدام تقنية الليزر الديود القابل للضبط (TDLAS) للقياس الدقيق والفوري لنقطة الندى ومحتوى الرطوبة في الغازات الصناعية. مراقبة حرجة لعمليات قطاع النفط والغاز والصناعة.',
        en: 'Panametrics Moisture IQ analyzers using Tunable Diode Laser Absorption Spectroscopy (TDLAS) technology for precise, real-time measurement of dew point and moisture content in industrial gases. Critical monitoring for Oil, Gas and Industry processes.'
      },
      features: [
        {
          fr: 'Technologie TDLAS - Laser à diode accordable',
          ar: 'تقنية TDLAS - ليزر ديود قابل للضبط',
          en: 'TDLAS Technology - Tunable Diode Laser'
        },
        {
          fr: 'Mesure en temps réel avec réponse ultra-rapide',
          ar: 'قياس فوري مع استجابة فائقة السرعة',
          en: 'Real-time measurement with ultra-fast response'
        },
        {
          fr: 'Plage étendue: -80°C à +20°C point de rosée',
          ar: 'نطاق واسع: -80°C إلى +20°C نقطة الندى',
          en: 'Wide range: -80°C to +20°C dew point'
        }
      ],
      color: '#DD6B20',
      image: 'https://drive.google.com/thumbnail?id=1CaZMU0OpBzVdop8AHb0oHBJyxl8G4rRn&sz=w1000',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
        </svg>
      )
    }
  ];

  const getLanguageText = (textObj) => {
    return textObj[language] || textObj.fr || textObj.en;
  };

  return (
    <section className="section section-light" style={{ 
      position: 'relative',
      padding: '6rem 0',
      overflow: 'hidden'
    }}>
      {/* Decorative elements */}
      <div style={{
        position: 'absolute',
        top: '5%',
        right: '-5%',
        width: '400px',
        height: '400px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.03) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '10%',
        left: '-5%',
        width: '300px',
        height: '300px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.03) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div className="container" style={{ 
        position: 'relative', 
        zIndex: 2,
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 1.5rem'
      }}>
        {/* Section header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '4rem'
        }}>
          <span style={{
            display: 'inline-block',
            padding: '0.5rem 1.5rem',
            backgroundColor: 'rgba(255, 107, 0, 0.1)',
            color: 'var(--assco-orange)',
            borderRadius: '30px',
            fontWeight: '600',
            fontSize: '0.875rem',
            marginBottom: '1rem',
            textTransform: 'uppercase'
          }}>
            {language === 'fr' ? 'INSTRUMENTATION DE PRÉCISION' : 
             language === 'ar' ? 'أجهزة قياس دقيقة' : 
             'PRECISION INSTRUMENTATION'}
          </span>

          <h2 style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            marginBottom: '1.5rem',
            color: '#1a202c',
            position: 'relative',
            display: 'inline-block'
          }}>
            {language === 'fr' ? 'Solutions d\'instrumentation avancées' : 
             language === 'ar' ? 'حلول قياس متقدمة' : 
             'Advanced Instrumentation Solutions'}
            <span style={{
              position: 'absolute',
              bottom: '-10px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '80px',
              height: '4px',
              backgroundColor: 'var(--assco-orange)',
              borderRadius: '2px'
            }}></span>
          </h2>
          <p style={{
            fontSize: '1.125rem',
            color: '#4a5568',
            maxWidth: '700px',
            margin: '0 auto',
            lineHeight: '1.7'
          }}>
            {language === 'fr' 
              ? 'Découvrez notre gamme de solutions d\'instrumentation Panametrics de haute précision pour le secteur Pétrole, Gaz et Industrie.' 
              : language === 'ar'
              ? 'اكتشف مجموعتنا من حلول القياس عالية الدقة من Panametrics لقطاع النفط والغاز والصناعة.'
              : 'Discover our range of high-precision Panametrics instrumentation solutions for the Oil, Gas and Industry sector.'}
          </p>
        </div>
        
        {/* Product tabs */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '3rem'
        }}>
          <div style={{
            display: 'flex',
            borderRadius: '100px',
            overflow: 'hidden',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            border: '1px solid #e2e8f0'
          }}>
            {products.map((product, index) => (
              <button 
                key={product.id}
                onClick={() => setActiveProduct(index)}
                style={{
                  padding: '0.75rem 1.5rem',
                  backgroundColor: activeProduct === index ? product.color : 'white',
                  color: activeProduct === index ? 'white' : '#4a5568',
                  fontWeight: '600',
                  fontSize: '0.95rem',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
              >
                <div style={{ 
                  width: '20px',
                  height: '20px',
                  color: activeProduct === index ? 'white' : product.color
                }}>
                  {product.icon}
                </div>
                <span className="md-hidden">
                  {getLanguageText(product.name)}
                </span>
              </button>
            ))}
          </div>
        </div>
        
        {/* Product showcase */}
        <div style={{
          backgroundColor: '#f8fafc',
          borderRadius: '24px',
          overflow: 'hidden',
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
          border: '1px solid #e2e8f0'
        }}>
          <div className="grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(12, 1fr)',
            minHeight: '500px'
          }}>
            {/* Product image */}
            <div className="col-span-5 md-col-span-12" style={{
              gridColumn: 'span 5',
              backgroundColor: products[activeProduct].color,
              position: 'relative',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '2rem'
            }}>
              {/* Background pattern */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                opacity: 0.5
              }}></div>
              
              {/* Real product image */}
              <div style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                zIndex: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2rem'
              }}>
                <div style={{
                  position: 'relative',
                  width: '100%',
                  maxWidth: '320px',
                  height: '280px',
                  borderRadius: '20px',
                  overflow: 'hidden',
                  boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3), 0 0 40px rgba(255, 255, 255, 0.1) inset',
                  border: '2px solid rgba(255, 255, 255, 0.3)',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  backdropFilter: 'blur(10px)',
                  transition: 'all 0.4s ease',
                  animation: 'float 6s ease-in-out infinite'
                }}>
                  <div style={{
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${products[activeProduct].image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    borderRadius: '18px',
                    position: 'relative'
                  }}>
                    {/* Overlay with product info */}
                    <div style={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
                      padding: '1.5rem 1rem 1rem',
                      color: 'white',
                      borderRadius: '0 0 18px 18px'
                    }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.75rem',
                        marginBottom: '0.5rem'
                      }}>
                        <div style={{
                          width: '32px',
                          height: '32px',
                          backgroundColor: 'rgba(255, 255, 255, 0.2)',
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <div style={{ 
                            width: '20px',
                            height: '20px',
                            color: 'white'
                          }}>
                            {products[activeProduct].icon}
                          </div>
                        </div>
                        <h4 style={{ 
                          margin: 0, 
                          fontSize: '1.1rem', 
                          fontWeight: '600',
                          textShadow: '0 2px 4px rgba(0,0,0,0.5)'
                        }}>
                          {getLanguageText(products[activeProduct].name)}
                        </h4>
                      </div>
                      <p style={{ 
                        margin: 0, 
                        fontSize: '0.85rem', 
                        opacity: 0.9,
                        textShadow: '0 1px 2px rgba(0,0,0,0.5)'
                      }}>
                        {products[activeProduct].features[0] ? getLanguageText(products[activeProduct].features[0]) : 'Panametrics'}
                      </p>
                    </div>
                    
                    {/* Fallback placeholder if image doesn't load */}
                    <div style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      textAlign: 'center',
                      color: 'rgba(255, 255, 255, 0.8)',
                      zIndex: -1
                    }}>
                      <div style={{
                        width: '60px',
                        height: '60px',
                        borderRadius: '50%',
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 1rem',
                        border: '2px dashed rgba(255, 255, 255, 0.4)'
                      }}>
                        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '24px', height: '24px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                      </div>
                      <p style={{ 
                        fontSize: '0.75rem', 
                        margin: 0, 
                        fontWeight: '500',
                        opacity: 0.7
                      }}>
                        {language === 'fr' ? 'Image du produit' :
                         language === 'ar' ? 'صورة المنتج' :
                         'Product Image'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Product tag */}
              <div style={{
                position: 'absolute',
                top: '20px',
                left: '20px',
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                backdropFilter: 'blur(10px)',
                borderRadius: '100px',
                padding: '0.5rem 1.25rem',
                color: 'white',
                fontWeight: '600',
                fontSize: '0.875rem',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                zIndex: 2
              }}>
                Panametrics
              </div>
            </div>
            
            {/* Product details */}
            <div className="col-span-7 md-col-span-12" style={{
              gridColumn: 'span 7',
              padding: '3rem',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}>
              <h3 style={{
                fontSize: '2rem',
                fontWeight: '700',
                marginBottom: '1.5rem',
                color: '#1a202c',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '12px',
                  backgroundColor: `${products[activeProduct].color}15`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: products[activeProduct].color
                }}>
                  <div style={{ width: '24px', height: '24px' }}>
                    {products[activeProduct].icon}
                  </div>
                </div>
                {getLanguageText(products[activeProduct].name)}
              </h3>
              
              <p style={{
                fontSize: '1.125rem',
                lineHeight: '1.8',
                color: '#4a5568',
                marginBottom: '2rem'
              }}>
                {getLanguageText(products[activeProduct].description)}
              </p>
              
              <h4 style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                marginBottom: '1.25rem',
                color: '#2d3748'
              }}>
                {language === 'fr' ? 'Caractéristiques clés' : 
                 language === 'ar' ? 'الميزات الرئيسية' : 
                 'Key Features'}
              </h4>
              
              <ul style={{
                listStyle: 'none',
                padding: 0,
                marginBottom: '2.5rem'
              }}>
                {products[activeProduct].features.map((feature, idx) => (
                  <li 
                    key={idx}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      marginBottom: '1rem',
                      gap: '0.75rem'
                    }}
                  >
                    <div style={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      backgroundColor: `${products[activeProduct].color}15`,
                      flexShrink: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginTop: '0.125rem'
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke={products[activeProduct].color}>
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span style={{ fontSize: '1.0625rem', color: '#4a5568' }}>
                      {getLanguageText(feature)}
                    </span>
                  </li>
                ))}
              </ul>
              
              <div style={{
                display: 'flex',
                gap: '1rem',
                marginTop: 'auto'
              }}>
                <Link 
                  to="/products"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.75rem',
                    backgroundColor: products[activeProduct].color,
                    color: 'white',
                    padding: '0.875rem 2rem',
                    borderRadius: '100px',
                    fontWeight: '600',
                    fontSize: '1rem',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    boxShadow: `0 10px 15px -3px ${products[activeProduct].color}40`
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = `0 20px 25px -5px ${products[activeProduct].color}40`;
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = `0 10px 15px -3px ${products[activeProduct].color}40`;
                  }}
                >
                  {language === 'fr' ? 'Voir tous les produits' : 
                   language === 'ar' ? 'عرض جميع المنتجات' : 
                   'View All Products'}
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </Link>
                
                <Link 
                  to="/contact"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.75rem',
                    backgroundColor: 'transparent',
                    color: products[activeProduct].color,
                    padding: '0.875rem 2rem',
                    borderRadius: '100px',
                    border: `2px solid ${products[activeProduct].color}`,
                    fontWeight: '600',
                    fontSize: '1rem',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = `${products[activeProduct].color}10`;
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  {language === 'fr' ? 'Demander un devis' : 
                   language === 'ar' ? 'طلب عرض أسعار' : 
                   'Request a Quote'}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <style jsx>{`
        @media (max-width: 768px) {
          .md-hidden {
            display: none;
          }
          
          .md-col-span-12 {
            grid-column: span 12;
          }
        }
        
        @keyframes float3d {
          0% {
            transform: translate(-50%, -50%);
          }
          50% {
            transform: translate(-50%, -60%);
          }
          100% {
            transform: translate(-50%, -50%);
          }
        }
        
        @keyframes float {
          0% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
          100% {
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};

export default ProductShowcaseSection;
